var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"room-grid-list-container"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"room-grids"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }